import styled from 'styled-components';

// Main
export const AppContainer = styled.div`
  * {
    font-family: ui-sans-serif, system-ui, sans serif !important;
  }
  width: 95%;
  margin-left: 5%;
  display: flex;
  height: 100vh;
  background: linear-gradient(to bottom right, #f9fafb, #f3f4f6);
`;

export const MainContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

// Sidebar
export const SidebarContainer = styled.div`
  border-right: 1px solid rgba(229, 231, 235, 0.8);
  height: 100%;
  width: ${props => (props.collapsed ? '0px' : '288px')};
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: ${props => (props.collapsed ? 'none' : 'blur(40px)')};
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
`;

export const SidebarContent = styled.div`
  height: 100%;
  width: 288px;
  display: flex;
  flex-direction: column;
  opacity: ${props => (props.collapsed ? 0 : 1)};
  transition: opacity 0.2s ease;
  pointer-events: ${props => (props.collapsed ? 'none' : 'auto')};
`;

export const ToggleButton = styled.div`
  position: absolute;
  top: 28px;
  right: ${props => (props.collapsed ? 'auto' : '24px')};
  left: ${props => (props.collapsed ? '24px' : 'auto')};
  border-radius: 8px;
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: ${props => (props.collapsed ? 'white' : 'transparent')};
  box-shadow: ${props => (props.collapsed ? '0 4px 6px -1px rgba(0, 0, 0, 0.1)' : 'none')};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 10;
  &:hover {
    background: ${props => (props.collapsed ? '#f9fafb' : '#f3f4f6')};
    transform: scale(1.05);
  }
  svg {
    color: ${props => (props.collapsed ? '#4f46e5' : '#9ca3af')};
    transition: color 0.3s ease;
  }
`;

export const LogoSection = styled.div`
  border-bottom: 1px solid rgba(229, 231, 235, 0.8);
  padding: 24px;
`;

export const LogoContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const LogoGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const LogoIcon = styled.div`
  border-radius: 16px;
  height: 40px;
  width: 40px;
  background: linear-gradient(to bottom right, #4f46e5, #6d28d9);
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  svg {
    color: white;
  }
`;

export const LogoTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
`;

export const LogoSubtitle = styled.div`
  font-size: 12px;
  color: #6b7280;
`;

export const ViewSwitcherSection = styled.div`
  border-bottom: 1px solid rgba(229, 231, 235, 0.8);
  padding: 16px;
`;

export const SearchInputWrapper = styled.div`
  position: relative;
  margin-bottom: 12px;
  width: 100%;
`;

export const StyledSearchInput = styled.input`
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  outline: none;
  width: 100%;
  padding: 8px 32px 8px 12px;
  font-size: 14px;
  transition: all 0.2s;
  &:focus {
    border-color: #a855f7;
    box-shadow: 0 0 0 3px rgba(168, 85, 247, 0.1);
  }
`;

export const ClearButton = styled.button`
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  padding: 0;
  color: #9ca3af;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: color 0.2s;
  &:hover {
    color: #4b5563;
  }
`;

export const ViewGrid = styled.div`
  border-radius: 12px;
  padding: 4px;
  background: #f3f4f6;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px;
`;

export const ViewButton = styled.button`
  border: none;
  border-radius: 8px;
  padding: 10px 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  background: ${props => (props.active ? 'white' : 'transparent')};
  color: ${props => (props.active ? '#111827' : '#4b5563')};
  box-shadow: ${props => (props.active ? '0 1px 2px 0 rgba(0, 0, 0, 0.05)' : 'none')};
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  transition: all 0.2s;
  ${props =>
    !props.disabled &&
    `&:hover {
    color: #111827;
  }`};
`;

export const NavigationSection = styled.div`
  padding: 16px;
  flex: 1;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background: #d1d5db;
  }
`;

export const NavGroup = styled.div`
  margin-bottom: 24px;
`;

export const NavGroupHeader = styled.div`
  margin-bottom: 12px;
  padding: 0 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const NavGroupTitle = styled.h3`
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #6b7280;
`;

export const AddButton = styled.button`
  border: none;
  border-radius: 8px;
  padding: 4px;
  background: transparent;
  cursor: pointer;
  transition: background 0.2s;
  &:hover {
    background: #f3f4f6;
  }
  svg {
    color: #9ca3af;
  }
`;

export const NavItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const FolderButton = styled.button`
  border: none;
  border-radius: 18px;
  width: 100%;
  padding: 9px 12px;
  padding-left: ${props => (props.level ? `${12 + props.level * 16}px` : '12px')};
  display: flex;
  align-items: center;
  gap: 10px;
  background: ${props => {
    if (props.selected) {
      if (props.status === 'all') return '#000';
      if (props.status === 'waiting') return 'linear-gradient(45deg, #f59e0b, #ea580c)';
      if (props.status === 'rejected') return 'linear-gradient(45deg, #ef4444, #f43f5e)';
      return 'linear-gradient(45deg, #6366f1, #7c3aed)';
    }
    return 'transparent';
  }};
  color: ${props => (props.selected ? 'white' : '#374151')};
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: ${props =>
    props.selected && props.status === undefined
      ? '0 20px 15px -3px rgba(199, 210, 254, 0.6), 0 10px 6px -4px rgba(199, 210, 254, 0.6)'
      : 'none'};
  &:hover {
    background: ${props => (props.selected ? '' : '#f3f4f6')};
    transform: ${props => (props.selected ? '' : 'translateX(2px)')};
  }
  ${props =>
    props.selected &&
    `
    svg {
      color: #fff;
    }
  `};
`;

export const ChevronIcon = styled.span`
  display: flex;
  align-items: center;
  color: ${props => (props.selected ? 'white' : '#9ca3af')};
  transition: transform 0.2s;
`;

export const FolderIcon = styled.span`
  display: flex;
  align-items: center;
  color: ${props => {
    if (props.selected) return 'white';
    if (props.status === 'waiting') return '#f59e0b';
    if (props.status === 'rejected') return '#ef4444';
    return '#6b7280';
  }};
  transition: color 0.2s;
`;

export const FolderName = styled.span`
  flex: 1;
  font-size: 14px;
  text-align: left;
`;

export const FolderCount = styled.span`
  border-radius: 9999px;
  padding: 2px 8px;
  font-size: 12px;
  background: ${props => {
    if (props.selected) return 'rgba(255, 255, 255, 0.2)';
    if (props.status === 'waiting') return '#fef3c7';
    if (props.status === 'rejected') return '#fee2e2';
    return '#e5e7eb';
  }};
  color: ${props => {
    if (props.selected) return 'white';
    if (props.status === 'waiting') return '#d97706';
    if (props.status === 'rejected') return '#dc2626';
    return '#4b5563';
  }};
  transition: all 0.2s;
`;

export const SubFolders = styled.div`
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const SidebarLoader = styled.div`
  height: 100px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 28px;
`;

export const Empty = styled.div`
  padding-block: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  p {
    font-size: 13px;
  }
`;

export const EmptyIcon = styled.div`
  margin-bottom: 5px;
  border-radius: 50%;
  height: 50px;
  width: 50px;
  background: #e5e7eb;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    color: #9ca3af;
  }
`;

// TagSearch
export const TagSearchContainer = styled.div`
  background: #f9fafb;
  border-radius: 16px;
  padding: 16px;
  border: 1px solid #e5e7eb;
`;

export const TagsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: ${props => (props.hasItems ? '12px' : '0')};
`;

export const TagBadge = styled.div`
  background: linear-gradient(to right, #6366f1, #a855f7);
  color: white;
  padding: 8px 16px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
`;

export const RemoveButton = styled.button`
  width: 20px;
  height: 20px;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }

  svg {
    color: white;
  }
`;

export const InputWrapper = styled.div`
  position: relative;
`;

export const StyledInput = styled.input`
  width: 100%;
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 12px;
  padding: 10px 16px;
  font-size: 14px;
  outline: none;
  transition: all 0.2s;

  &::placeholder {
    color: #9ca3af;
  }

  &:focus {
    border-color: #6366f1;
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
  }
`;

// TopBar
export const TopBarContainer = styled.div`
  border-bottom: 1px solid rgba(229, 231, 235, 0.8);
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(40px);
`;

export const TopSection = styled.div`
  padding: ${props => (props.sidebarCollapsed ? '32px 80px 24px' : '32px 32px 24px')};
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  transition: padding 0.3s ease;
`;

export const Title = styled.h1`
  margin-bottom: 8px;
  background: linear-gradient(to right, #111827, #4b5563);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 40px;
`;

export const Subtitle = styled.p`
  font-size: 14px;
  color: #6b7280;
`;

export const BottomSection = styled.div`
  padding: ${props => (props.sidebarCollapsed ? '16px 80px 24px' : '16px 32px 24px')};
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  transition: padding 0.3s ease;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
`;

export const ButtonWrapper = styled.div`
  position: relative;
  &:hover .plus-button {
    opacity: 1;
  }
`;

export const PlusButton = styled.button`
  position: absolute;
  top: -32px;
  left: 50%;
  transform: translateX(-50%);
  border: none;
  border-radius: 50%;
  height: 28px;
  width: 28px;
  background: #1f2937;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  z-index: 10;
  transition: all 0.2s;
  cursor: pointer;
  &:hover {
    transform: translateX(-50%) scale(1.1);
  }
  svg {
    color: white;
  }
`;

export const TopBarViewButton = styled.button`
  border: ${props => (props.active ? 'none' : '1px solid #e5e7eb')};
  border-radius: 16px;
  padding: 10px 20px;
  background: ${props => props.active ? 'linear-gradient(to right, rgb(107, 141, 214), rgb(142, 55, 215))'
      : 'linear-gradient(to right, rgb(239, 157, 67), rgb(231, 85, 22))'};      
  color: white;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
`;

// Card
export const Card = styled.div`
  border: 1px solid #f3f4f6;
  border-radius: 16px;
  background: white;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.3s;
  &:hover {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  }
`;

export const PreviewSection = styled.div`
  border-bottom: 1px solid #e0dada;
  position: relative;
  aspect-ratio: 3/4;
  display: grid;
  place-items: center;
  background: #fff;
  overflow: hidden;
  cursor: pointer;
`;

export const PreviewImage = styled.img`
  transition: transform 0.5s;
  ${Card}:hover & {
    transform: scale(1.1);
  }
`;

export const GradientOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.6), transparent, transparent);
  opacity: 0;
  transition: opacity 0.3s;
  ${Card}:hover & {
    opacity: 1;
  }
`;

export const LanguageBadge = styled.div`
  position: absolute;
  top: 16px;
  left: 16px;
  border-radius: 12px;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 8px;
  svg {
    color: #4f46e5;
  }
  span {
    font-size: 12px;
  }
`;

export const TopActions = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  display: flex;
  gap: 8px;
  opacity: ${props => (props.visible ? 1 : 0)};
  transform: ${props => (props.visible ? 'translateY(0)' : 'translateY(-8px)')};
  transition: all 0.3s;
`;

export const ActionButton = styled.button`
  border: none;
  border-radius: 12px;
  height: 36px;
  width: 36px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.2s;
  position: relative;
  &:hover {
    transform: scale(1.1);
  }
  &:hover {
    opacity: 1;
    visibility: visible;
  }
  svg {
    color: #4b5563;
  }
`;

export const BottomActions = styled.div`
  position: absolute;
  right: 8px;
  bottom: 8px;
  left: 8px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
`;

export const PageDate = styled.div`
  border-radius: 12px;
  width: 60px;
  padding: 6px 12px;
  background: rgb(243, 242, 245);
  font-size: 12px;
  text-align: center;
  p {
    font-size: 18px;
    font-weight: 600;
    color: #000;
  }
  span {
    font-weight: 600;
    text-transform: uppercase;
    color: rgb(136, 136, 136);
  }
`;

export const InfoSection = styled.div`
  padding: 16px;
  .badge_wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
`;

export const CardTitle = styled.h3`
  margin-bottom: 12px;
  font-size: 14px;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color 0.2s;
  ${Card}:hover & {
    color: #4f46e5;
  }
`;

export const CategoryBadge = styled.div`
  border: 1px solid #5eead4;
  border-radius: 12px;
  padding: 6px 12px;
  max-width: 100%;
  font-size: 12px;
  background: linear-gradient(to right, #f0fdfa, #ccfbf1);
  color: #0f766e;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
`;

export const LanguageSelector = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
`;

export const LanguageButton = styled.button`
  border: 1px solid;
  border-radius: 12px;
  padding: 6px 10px;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
  img {
    width: 16px;
  }
  &:hover {
    opacity: 1;
    visibility: visible;
  }
  ${props => {
    if (props.selected) {
      return `
      border-color: transparent;
        background: linear-gradient(to right, #6366f1, #a855f7);
        color: white;
        box-shadow: 0 2px 4px 0 rgba(99, 102, 241, 0.3);
        transform: scale(1.05);
      `;
    } else if (props.highlighted) {
      return `
      border-color: #a5b4fc;
        background: linear-gradient(to right, #e0e7ff, #ede9fe);
        color: #4f46e5;
      `;
    } else {
      return `
      border-color: #e5e7eb;
        background: #f3f4f6;
        color: #4b5563;
        
        &:hover {
          background: #e5e7eb;
        }
      `;
    }
  }}
  span:first-child {
    font-size: 16px;
    line-height: 1;
  }
  span:last-child {
    text-transform: uppercase;
  }
`;

export const SingleLanguageBadge = styled.div`
  border: 1px solid #c7d2fe;
  border-radius: 12px;
  padding: 6px 12px;
  font-size: 12px;
  text-transform: uppercase;
  background: linear-gradient(to right, #eef2ff, #f5f3ff);
  color: #4f46e5;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  img {
    width: 16px;
  }
  span:first-child {
    font-size: 16px;
    line-height: 1;
  }
`;

export const LanguagePopover = styled.div`
  max-width: 320px;
  .popover_header {
    margin-bottom: 8px;
    border-bottom: 1px solid #f3f4f6;
    padding: 0 0 8px;
    font-size: 11px;
    font-weight: 600;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }
  .popover_body {
    max-height: 250px;
    padding-inline: 2px;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    overflow-y: auto;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    ::-webkit-scrollbar {
      display: none;
    }
  }
`;

// Grid
export const Header = styled.div`
  margin-bottom: 32px;
`;

export const HeaderTop = styled.div`
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const HeaderTitle = styled.h2`
  margin-bottom: 8px;
  font-size: 30px;
  background: linear-gradient(to right, #111827, #4b5563);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

export const HeaderSubtitle = styled.p`
  font-size: 14px;
  color: #6b7280;
`;

export const Actions = styled.div`
  display: flex;
  gap: 8px;
`;

export const DropdownWrapper = styled.div`
  position: relative;
`;

export const SortButton = styled.button`
  border: 1px solid #e5e7eb;
  border-radius: 18px;
  padding: 8px 14px;
  background: white;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    border-color: #a78bfa;
  }
  svg:last-child {
    transition: transform 0.2s;
    transform: ${props => (props.open ? 'rotate(180deg)' : 'rotate(0)')};
  }
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  width: 192px;
  padding: 4px;
  background: white;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  z-index: 10;
  display: ${props => (props.visible ? 'block' : 'none')};
`;

export const MenuItem = styled.button`
  border: none;
  border-radius: 8px;
  width: 100%;
  padding: 10px 16px;
  background: white;
  font-size: 14px;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: background 0.2s;
  &:hover {
    background: #f9fafb;
  }
  svg {
    color: #6366f1;
  }
`;

export const EmptyState = styled.div`
  padding: 80px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #6b7280;
`;

export const EmptyIconWrapper = styled.div`
  margin-bottom: 16px;
  border-radius: 50%;
  height: 96px;
  width: 96px;
  background: #e5e7eb;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    color: #9ca3af;
  }
`;

export const EmptyTitle = styled.p`
  margin-bottom: 4px;
  font-size: 18px;
`;

export const EmptySubtitle = styled.p`
  font-size: 14px;
`;

export const GridLayout = styled.div`
  width: 100%;
  display: grid;
  justify-content: start;
  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  gap: 32px;
  @media (min-width: 1520px) {
    grid-template-columns: repeat(auto-fit, minmax(225px, 1fr));
  }

  .observer_div {
    width: 100%;
    text-align: center;
    grid-column: 1 / -1;
  }
`;